import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'
import { signUpCtaLocationForTab } from '@/helpers/telemetry/signupLinkTracking'

import type { FaqSection } from './cstFaqDetails'
import { SellerProfileLexicalRichText } from './SellerProfileLexicalRichText'

export function hasCmsFaqBody(profile: CmsSellerProfile): boolean {
  const sections = profile.faqSections
  if (!Array.isArray(sections)) return false
  return sections.some((s) => {
    const hasTitle = typeof s.title === 'string' && s.title.trim().length > 0
    const qs = s.questions
    const hasQuestion =
      Array.isArray(qs) &&
      qs.some(
        (q) => typeof q.question === 'string' && q.question.trim().length > 0
      )
    return hasTitle && hasQuestion
  })
}

export function buildCmsFaqSections(profile: CmsSellerProfile): FaqSection[] {
  const sections = profile.faqSections
  if (!Array.isArray(sections)) return []
  const signUpCtaLocation = signUpCtaLocationForTab(profile.sellerSlug, 'faq')
  const out: FaqSection[] = []
  for (const sec of sections) {
    const title = typeof sec.title === 'string' ? sec.title.trim() : ''
    if (!title) continue
    const questions = (sec.questions ?? [])
      .map((q) => {
        const question = typeof q.question === 'string' ? q.question.trim() : ''
        if (!question) return null
        const answerNode = q.answer ? (
          <SellerProfileLexicalRichText
            data={q.answer}
            signUpCtaLocation={signUpCtaLocation}
          />
        ) : (
          ''
        )
        return { question, answer: answerNode }
      })
      .filter((item): item is NonNullable<typeof item> => item !== null)
    if (questions.length > 0) {
      out.push({ title, questions })
    }
  }
  return out
}
